export const GLOBAL_CONFIG_KEY = '_fwGlobalConfig';
